import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { MDBDataTable } from 'mdbreact';
import Tooltip from '../../common/toolTip';
import CertificateAdd from './add';
import CertificateDelete from './delete';
import axios from 'axios';
import { baseUrl, ROUTE_BASE_URL } from '../../../api/common';
import { useUser } from '../../AdminUsers/UserContext';
const Certificate = () => {
    const { checkPermission } = useUser();
    const [addPopupStatus, setAddPopupStatus] = useState(false);

    const [updateData, setUpdateData] = useState({});

    const [eventType, setEventType] = useState('');

    const handleAddPopup = async(status, type, data) => {
        setUpdateData(data);
        setEventType(type);
        if(type==="Add"){
            const hasPermission = await checkPermission("FMAS Certificate", "create");
            if (!hasPermission) return;
          }else{
            const hasPermission = await checkPermission("FMAS Certificate", "update");
            if (!hasPermission) return;
        }
        setAddPopupStatus(status);
        setViewPopupStatus(false);
    };

    const [viewPopupStatus, setViewPopupStatus] = useState(false);
    
    const handleViewPopup = (type,data) => {
        setUpdateData(data);
        setEventType(type);
        setViewPopupStatus(true);
    };

    const handleViewPopupClose = () => {
        setEventType('');
        setUpdateData({});
        setViewPopupStatus(false);
    };
    const handleDuplicate = (id) => {
      fetchDuplicateCertificateData(id);
    };
    const [deletePopupStatus, setDeletePopupStatus] = useState(false);
    const [deleteId, setDeleteId] = useState();
    const handleDelete = async (id) => {
        setDeleteId(id);      
        const hasPermission = await checkPermission("FMAS Certificate", "delete");
        if (!hasPermission) return;      
        setDeletePopupStatus(true);
    };

    const handleCloseDelete = () => {
        setDeletePopupStatus(false);
        setViewPopupStatus(false);
    };

    const [certificateData, setCertificateData] = useState([]);

    const fetchCertificateData = async () => {
        try {
          const response = await axios.post(
            `${baseUrl}/api/fmascertificate_list`,
            // {member_apply_date:""},     
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: localStorage.getItem('access_token'),
              },
            }
          );
    
          if (response.data.status) {          
            setCertificateData(response.data.data);
          } else {
            console.error('Error: Failed to fetch user data');
          }
        } catch (error) {
          console.error('Error fetching users data:', error);
        }
    };

    const body = {
        columns: [
            {
                label: 'S.No',
                field: 'sno',
                attributes: {
                    style: { width: '2%', fontWeight: 'bold' },
                },
            },
            {
                label: 'Year',
                field: 'year_of_fmas',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Name',
                    style: { width: '50%', fontWeight: 'bold' },
                },
            },
            {
                label: 'President Name',
                field: 'president_name',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Name',
                    style: { width: '50%', fontWeight: 'bold' },
                },
            },
            {
                label: 'certificate',
                field: 'certificate_file',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Name',
                    style: { width: '50%', fontWeight: 'bold' },
                },
            },
            // {
            //     label: 'Top Logo',
            //     field: 'top_logo',
            //     attributes: {
            //         'aria-controls': 'DataTable',
            //         'aria-label': 'Name',
            //         style: { width: '50%', fontWeight: 'bold' },
            //     },
            // },
            // {
            //     label: 'Bottom Logo',
            //     field: 'bottom_logo',
            //     attributes: {
            //         'aria-controls': 'DataTable',
            //         'aria-label': 'Name',
            //         style: { width: '50%', fontWeight: 'bold' },
            //     },
            // },
            {
                label: 'Action',
                field: 'action',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Action',
                    style: { width: '1%', fontWeight: 'bold' },
                },
            }
        ],
        rows:certificateData&&certificateData.map((data, index) => ({
            sno: index + 1,
            year_of_fmas: data.year_of_fmas || "N/A",
            president_name: data.president_name || "N/A",
            certificate_file:<img src={`${baseUrl}/${data.certificate_file}`} width={90} alt="Amasi" className="img-fluid logo" />  || "N/A",
            action: (
                <div>
                  {/* <Tooltip text="Duplicate" id="duplicate" />
                  <button 
                    type="button" 
                    onClick={(e) => { e.stopPropagation(); handleDuplicate(data.id, "Update", data); }}
                    className="btn btn-sm btn-default edit_button_package" 
                    title="Duplicate"
                    data-for="duplicate" 
                    data-tip
                  >
                    <i className="fa fa-clone"></i>
                  </button> */}
                  <Tooltip text="Update" id="update" />
                  <button 
                    type="button" 
                    onClick={(e) => { e.stopPropagation(); handleAddPopup(true, "Update", data); }}
                    className="btn btn-sm btn-default edit_button_package" 
                    title="Edit"
                    data-for="update" 
                    data-tip
                  >
                    <i className="fa fa-edit"></i>
                  </button>
                  <Tooltip text="Delete" id="delete" />
                  <button 
                    type="button" 
                    onClick={(e) => { e.stopPropagation(); handleDelete(data.id); }} 
                    className="btn btn-sm btn-default delete_button_package" 
                    title="Delete"
                    data-for="delete" 
                    data-tip
                  >
                    <i className="fa fa-trash"></i>
                  </button>
                </div>
            ),           
            clickEvent: () => handleViewPopup("Update",data),
        })),
    }

    const fetchDuplicateCertificateData = async (certificateId) => {
        try {
          const response = await axios.post(
            `${baseUrl}/api/certificate_duplicate`,
            {
                id:certificateId
            },     
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: localStorage.getItem('access_token'),
              },
            }
          );
    
          if (response.data.status) {
            fetchCertificateData();          
            setCertificateData(response.data.data);
            console.log("certificate_duplicate", response.data.data);
            handleViewPopup("Update", response.data.data[0]);
          } else {
            console.error('Error: Failed to fetch user data');
          }
        } catch (error) {
          console.error('Error fetching users data:', error);
        }
    };
     // Check Admin User Permission
     const [checkUserLoading, setCheckUserLoading] = useState(false); 
     const fetchPermission = async () => {
       setCheckUserLoading(true);
       try {
         const hasPermission = await checkPermission("FMAS Certificate", "view");
         if (!hasPermission) return;
       } catch (error) {
         console.error("Error fetching super specialty data:", error);
       }finally{
         setCheckUserLoading(false);
       }
     };
     useEffect(() => {
       fetchPermission();
     }, []);
    useEffect(() => {
      fetchCertificateData();
    }, []);

    return (
        <>
        {checkUserLoading? (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "500px" }}>
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
            ) : (
            <div className="container-fluid">
                <div className="block-header">
                    <div className="row clearfix">
                        <div className="col-md-6 col-sm-12">
                            <h1>FMAS Certificate Master</h1>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to={`${ROUTE_BASE_URL}/`}>AMASI</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">FMAS Certificate Master</li>
                                </ol>
                            </nav>
                        </div>
                        <div className="col-md-6 col-sm-12 text-right hidden-xs">
                            <span onClick={() => handleAddPopup(true,"Add",{})} className="btn btn-outline-primary mr-1" title="">Add New</span>
                        </div>
                    </div>
                </div>
                <div className="row clearfix">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="body">
                                <div className="table-responsive">
                                    <MDBDataTable
                                        noBottomColumns
                                        className="table table-hover js-basic-example dataTable table-custom spacing5"
                                        entriesOptions={[5, 10, 20]}
                                        entries={5}
                                        paging
                                        pagesAmount={5}
                                        data={body}
                                        sortRows={['title']}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <CertificateAdd fetchCertificateData={fetchCertificateData} eventType={eventType} updateData={updateData} addPopupStatus={addPopupStatus} handleAddPopup={handleAddPopup} />
                <CertificateDelete fetchCertificateData={fetchCertificateData} deleteId={deleteId} deletePopupStatus={deletePopupStatus} handleCloseDelete={handleCloseDelete}/>

                {updateData&&<div className={`extraspace_search_div search_div${viewPopupStatus ? " open" : ""}`}>
                    <div className="card member_master_sidebar_scrool">
                        <div className="member_edit_pop_flex mb-3 text-end">
                            <h3>View Certificate</h3>
                            <div className="input-group-append d-flex gap-10">
                                <div>
                                    <button onClick={()=>handleDelete(updateData.id)} className="saveand_proced_button btn btn btn-outline-danger btn-block" type="button"><i className="icon-trash"></i> Delete </button>
                                </div>
                                <div>
                                    <button onClick={()=> handleAddPopup(true,"Update",updateData)} className="saveand_proced_button btn btn-outline-info btn-block" type="button"><i className="fa fa-edit"></i> Edit </button>
                                </div>
                                <span onClick={() =>handleViewPopupClose()} className="search_toggle btn btn-danger"><i className="fa fa-times"></i></span>
                            </div>
                        </div>
                        <div className="table-responsive">
                            <div className="body  application_body_side">
                                <fieldset>
                                    <div className="row clearfix">
                                        <div className="col-md-12">
                                            <div className="card">
                                                <div className="body">
                                                    <div className="row">
                                                        <div className="col-6">
                                                            <small className="text-muted"><b>Year</b> </small>
                                                            <p>{updateData.year_of_fmas}</p>
                                                        </div>
                                                        <div className="col-6">
                                                            <small className="text-muted"><b>President Name</b> </small>
                                                            <p>{updateData.president_name}</p>
                                                        </div>
                                                        <div className="col-6">
                                                            <small className="text-muted"><b>Certificate</b> </small>
                                                            <p><img src={`${baseUrl}/${updateData.certificate_file}`} width={100} alt="Amasi" className="img-fluid logo" /></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                    </div>
                </div>}

            </div>)}
        </>

    );

}
export default Certificate
